import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13906b72"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "chatModal",
  tabindex: "-1",
  "aria-labelledby": "chatModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "row p-3" }
const _hoisted_5 = { class: "user-info d-flex align-items-center col-9" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_7 = {
  key: 0,
  class: "fs-7 fw-bold cursor-pointer"
}
const _hoisted_8 = {
  key: 1,
  class: "fw-bold fs-7"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "fs-8 date-text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end col-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom mx-2" }, null, -1))
const _hoisted_13 = { class: "modal-body p-4" }
const _hoisted_14 = { class: "content pb-3 position-relative" }
const _hoisted_15 = { class: "fw-bold fs-6 text-break" }
const _hoisted_16 = { class: "content" }
const _hoisted_17 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 2,
  class: "file-container d-flex justify-content-between align-items-center"
}
const _hoisted_20 = { class: "d-flex align-items-center text-truncate" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-2" }, null, -1))
const _hoisted_22 = { class: "mb-0 text-truncate" }

import Category from '@/components/category/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Avatar from '@/components/avatar'
import { computed } from 'vue-demi'
import TargetTag from '@/components/target-tag/index.vue'
import { PostType } from '@/store/modules/post'
import { POST_STORE, COMMUNITY_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import relativeTime from 'dayjs/plugin/relativeTime'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import { ChangeTime } from '@/constants/datepicker'
import { ReplayName } from '@/constants/common'
import PostFileDownload from '@/views/shared/communities/components/PostFileDownload.vue'
import { CommunityStateTypes } from '@/store/modules/community'
import { addPostParams } from '@/use/usePath'
import UrlDisplay from '@/components/post-url/UrlDisplay.vue'
import { isEmpty } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  props: {
  create_by_admin: Boolean,
},
  setup(__props) {

dayjs.locale('ja')

dayjs.extend(relativeTime)
const store = useStore()

const post = computed<PostType>(() => store.getters[POST_STORE.GETTERS.POST])
const me = computed<Pick<CommunityStateTypes, 'me'>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])



const shouldShowUrl = () => !isEmpty(post.value.site_name_1) || !isEmpty(post.value.site_url_1) || !isEmpty(post.value.site_name_2) || !isEmpty(post.value.site_url_2)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createVNode(_unref(Avatar), {
                is_deleted_in_30_days: _unref(post)?.user_post?.is_deleted_in_30_days,
                user_image_url: _unref(post)?.user_post?.avatar_url,
                userType: _unref(post)?.user_post?.user_type
              }, null, 8, ["is_deleted_in_30_days", "user_image_url", "userType"])
            ]),
            _createElementVNode("div", null, [
              (__props.create_by_admin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(UserAliasIcon, {
                      userType: _unref(post)?.user_post?.user_type
                    }, null, 8, ["userType"]),
                    (_unref(post)?.user_post?.user_type !== 'community_admin')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(post)?.user_post?.management_no +
                    ' ' +
                    _unref(ReplayName)(
                      _unref(post)?.user_post?.is_deleted_in_30_days,
                      _unref(post)?.user_post?.available,
                      _unref(post)?.user_post?.family_name,
                      _unref(post)?.user_post?.given_name,
                      _unref(post)?.user_post?.user_type
                    )) + " " + _toDisplayString(_unref(post)?.user_post?.user_type == 'alumni' && [0, 1].includes(_unref(post)?.user_post?.is_deleted_in_30_days) ? `（ ${_unref(post)?.user_post?.display_name} ）` : ''), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(post)?.user_post?.display_name), 1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(UserAliasIcon, {
                      title: _unref(post)?.user_post?.display_name,
                      userType: _unref(post)?.user_post?.user_type
                    }, null, 8, ["title", "userType"])
                  ])),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(ChangeTime)(_unref(post)?.created_at)), 1)
            ])
          ]),
          _hoisted_11
        ]),
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(Category, {
              content_type: _unref(post)?.content_type
            }, null, 8, ["content_type"]),
            _createElementVNode("h3", _hoisted_15, _toDisplayString(_unref(post)?.title), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(TargetTag, {
              data: _unref(post)?.content,
              class: "mb-2 break-spaces text-break"
            }, null, 8, ["data"]),
            (_unref(post) && shouldShowUrl())
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(UrlDisplay, {
                    "site-url": _unref(post).site_url_1,
                    "site-name": _unref(post).site_name_1
                  }, null, 8, ["site-url", "site-name"]),
                  _createVNode(UrlDisplay, {
                    "site-url": _unref(post).site_url_2,
                    "site-name": _unref(post).site_name_2
                  }, null, 8, ["site-url", "site-name"])
                ]))
              : _createCommentVNode("", true),
            (_unref(post)?.image_url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _unref(addPostParams)(_unref(post).image_url, _unref(post).content_type),
                  alt: "post image",
                  class: "img-url w-100 h-100 mb-4"
                }, null, 8, _hoisted_18))
              : _createCommentVNode("", true),
            (_unref(post)?.file_url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(post)?.file_url.split('/').slice(-1)[0]), 1)
                  ]),
                  _createVNode(PostFileDownload, {
                    className: "rounded-circle cursor-pointer",
                    communityId: _unref(me).community_id,
                    postId: _unref(post).id,
                    fileDownloadName: _unref(post)?.file_url.split('/').slice(-1)[0]
                  }, null, 8, ["communityId", "postId", "fileDownloadName"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})